import React from 'react';
import PropTypes from 'prop-types';
import { useScrollTrigger } from '@mui/material';

const ElevationScroll = ({ children }) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  });
};

ElevationScroll.propTypes = {
  children: PropTypes.node.isRequired
};

export default ElevationScroll;
